function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { BottomSheetContentLayout, Box, GridItem, MenuItem, Select, TextButton, TextField, useDevice, useOverlayContext, WithInfoIcon } from 'seagull';
import { getCustomMessageValidation, validateViaRHF } from "../../../../business-logic/validators";
import { useStoreActions } from "../../../../store/store-context";
import { connectControllerToTextField } from "../../../../utils/react-hook-form.utils";
import { useTextFieldVariableIntegration } from "../../TemplateVariables/hooks/useTextFieldVariableIntegration";
import { VariableFieldAdornment } from "../../TemplateVariables/VariableFieldAdornment/VariableFieldAdornment";
import { VariablePickerPopover } from "../../TemplateVariables/VariablePickerPopover/VariablePickerPopover";
import { VariablePreviewLine } from "../../TemplateVariables/VariablePreviewLine/VariablePreviewLine";
import styles from "./IntroMessage.module.scss";
import { isCustomMessageType, orderedTemplateTypesForDropdown, templateTypeToDropdownLabel, useEditIntroMessage } from "./IntroMessage.utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const messageRules = getCustomMessageValidation('Introductory message', true);
const textFieldProps = {
  collapseHelperText: false,
  testId: 'template-content',
  placeholder: 'Your message…',
  multiline: true,
  minRows: 9,
  maxRows: 9
};
export function validateIntroMessage(value) {
  return validateViaRHF(messageRules, value);
}
function EditMessageInBottomSheet(props) {
  const {
    headerTitle,
    message,
    onChange
  } = props;
  const {
    control,
    getValues
  } = useForm({
    mode: 'all',
    defaultValues: {
      message
    }
  });
  return /*#__PURE__*/_jsx(BottomSheetContentLayout, {
    header: {
      title: headerTitle
    },
    footer: {
      primaryAction: {
        text: 'Save',
        onClick: () => onChange(getValues('message'))
      }
    },
    children: /*#__PURE__*/_jsx(Box, {
      padding: 8,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "message",
        rules: messageRules,
        render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), textFieldProps))
      })
    })
  });
}
export default function IntroMessage(props) {
  const {
    initialTemplateContent,
    disabled,
    onMessageChange,
    inputWidth = '512px'
  } = props;
  const {
    getTemplateTypeByMessage,
    templateTypeToContent
  } = useEditIntroMessage();
  const {
    logBI
  } = useStoreActions();
  const {
    isMobileDevice
  } = useDevice();
  const {
    pushBottomSheetPage,
    popBottomSheetPage
  } = useOverlayContext();
  const defaultValues = {
    type: getTemplateTypeByMessage(initialTemplateContent),
    message: initialTemplateContent
  };
  const [customMessage, setCustomMessage] = useState(isCustomMessageType(defaultValues.type) ? initialTemplateContent : '');
  const {
    control,
    setValue,
    getValues,
    watch
  } = useForm({
    mode: 'all',
    defaultValues
  });
  const [showTemplateMessage, setShowTemplateMessage] = useState(false);
  const _inputRef = useRef(null);
  const watchedMessage = watch('message');
  const onTypeChange = newType => {
    logBI(10491, {
      templateType: newType
    });
    const newMessage = isCustomMessageType(newType) ? customMessage : templateTypeToContent[newType];
    if (isCustomMessageType(newType)) setShowTemplateMessage(true);
    setValues({
      newType,
      newMessage
    });
  };
  const onEditMessage = newMessage => {
    const newType = getTemplateTypeByMessage(newMessage);
    if (isCustomMessageType(newType)) setCustomMessage(newMessage);
    setValues({
      newType,
      newMessage
    });
  };
  const setValues = _ref => {
    let {
      newType,
      newMessage
    } = _ref;
    const [type, message] = getValues(['type', 'message']);
    if (newMessage !== type) {
      setValue('type', newType);
    }
    if (newMessage !== message) {
      onMessageChange(newMessage);
      setValue('message', newMessage);
    }
  };
  const setMessageField = useCallback(newValue => {
    onEditMessage(newValue);
  }, [onEditMessage]);
  const {
    enabled,
    inputProps,
    adornmentRef,
    adornmentStyle,
    fieldAdornmentProps,
    resolvedValues,
    pickerPopoverProps
  } = useTextFieldVariableIntegration(_inputRef, setMessageField, {
    disabled,
    adornmentStyle: {
      alignSelf: 'flex-start',
      marginTop: -8
    }
  });
  useEffect(() => {
    if (!isMobileDevice) return;
    if (showTemplateMessage) {
      pushBottomSheetPage({
        onClose: () => setShowTemplateMessage(false),
        content: /*#__PURE__*/_jsx(EditMessageInBottomSheet, {
          headerTitle: templateTypeToDropdownLabel[getValues('type')],
          message: getValues('message'),
          onChange: message => {
            onEditMessage(message);
            setShowTemplateMessage(false);
          }
        })
      });
    } else {
      popBottomSheetPage();
    }
  }, [showTemplateMessage]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(GridItem, {
      span: 12,
      className: styles.firstRow,
      testId: "intro-message",
      children: [/*#__PURE__*/_jsx(WithInfoIcon, {
        className: styles.inputContainer,
        info: "This message will show as an introductory message on the agreement and the email your client receives. You can configure the default messages in your business settings.",
        children: /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "type",
          render: renderProps => /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
            collapseHelperText: false
          }, connectControllerToTextField(renderProps)), {}, {
            onChange: e => {
              onTypeChange(e.target.value);
              renderProps.field.onChange(e);
            },
            testId: "template-type-dropdown",
            label: "Introductory message",
            disabled: disabled,
            style: {
              width: inputWidth
            },
            children: orderedTemplateTypesForDropdown.map(templateType => /*#__PURE__*/_jsx(MenuItem, {
              value: templateType,
              testId: "template-type-".concat(templateType),
              children: templateTypeToDropdownLabel[templateType]
            }, templateType))
          }))
        })
      }), /*#__PURE__*/_jsx(TextButton, {
        testId: "edit-message",
        disabled: disabled,
        onClick: () => {
          logBI(10490);
          setShowTemplateMessage(true);
        },
        style: {
          visibility: isMobileDevice || !showTemplateMessage ? 'visible' : 'hidden'
        },
        children: "Edit message"
      })]
    }), showTemplateMessage && !isMobileDevice && /*#__PURE__*/_jsxs(GridItem, {
      span: 12,
      children: [/*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "message",
        rules: messageRules,
        render: renderProps => {
          const connected = connectControllerToTextField(renderProps);
          const rhfRef = connected.inputRef;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread(_objectSpread({}, connected), textFieldProps), {}, {
            inputRef: el => {
              _inputRef.current = el;
              if (typeof rhfRef === 'function') {
                rhfRef(el);
              }
            },
            inputProps: inputProps,
            onChange: e => {
              onEditMessage(e.target.value);
              renderProps.field.onChange(e);
            },
            disabled: disabled,
            InputProps: enabled ? {
              endAdornment: /*#__PURE__*/_jsx("span", {
                ref: adornmentRef,
                style: adornmentStyle,
                children: /*#__PURE__*/_jsx(VariableFieldAdornment, _objectSpread({}, fieldAdornmentProps))
              })
            } : undefined
          }));
        }
      }), enabled && /*#__PURE__*/_jsx(VariablePreviewLine, {
        text: watchedMessage,
        resolvedValues: resolvedValues
      })]
    }), enabled && /*#__PURE__*/_jsx(VariablePickerPopover, _objectSpread({}, pickerPopoverProps))]
  });
}